var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 114,
    r: 60,
    transform: "translate(-458 -50)",
    stroke: "#FFF",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd"
  })));
}
export default SvgOval;